var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnSideBarMenuTotalViewHover({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 64,
    viewBox: "0 0 75 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.1,
    fill: "#4F5FD8",
    cx: 38,
    cy: 32,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#4F5FD8",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 24.551h16M30 31.662h16M30 38.773h16"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnSideBarMenuTotalViewHover);
export default __webpack_public_path__ + "static/media/btn-side-bar-menu-total-view-hover.34a78fcb9f152452ff854234789c7ad6.svg";
export { ForwardRef as ReactComponent };